import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import Spinner from "react-bootstrap/Spinner";

import TickOutlined from "../../Icon/TickOutlined";

const CompleteStatus = ({ complete, isLoading }) =>
  isLoading ? (
    <Spinner
      animation="border"
      className={classNames("mydpd-step-loader")}
      size="sm"
    />
  ) : (
    <TickOutlined color={complete ? "#8AC149" : "#e6e6e6"} />
  );

CompleteStatus.propTypes = {
  complete: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default CompleteStatus;
